(() => {
  const openModal = (id) => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.open) dialog.showModal();
  };

  const closeModal = (dialog) => {
    if (dialog && dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-tv-size-guide-open]');
    if (openBtn) {
      event.preventDefault();
      openModal(openBtn.getAttribute('data-tv-size-guide-open'));
      return;
    }

    const closeBtn = event.target.closest('[data-tv-size-guide-close]');
    if (closeBtn) {
      event.preventDefault();
      closeModal(closeBtn.closest('dialog'));
      return;
    }

    // Click on dialog backdrop closes
    const dialog = event.target;
    if (dialog && dialog.matches && dialog.matches('dialog.tv-size-guide-modal')) {
      const rect = dialog.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!inside) closeModal(dialog);
    }
  });
})();
